TrelloModel = require 'models/internal/trello-model'
_ = require 'underscore'

# emoji-mart uses number values to map out the skin variations
skinUnifiedMap = {
  1: ''
  2: '1F3FB'
  3: '1F3FC'
  4: '1F3FD'
  5: '1F3FE'
  6: '1F3FF'
}
unifiedSkinMap = _.invert(skinUnifiedMap)

module.exports = class Reaction extends TrelloModel
  typeName: 'Reaction'

  urlRoot: ->
    "/1/actions/#{ @get('idModel') }/reactions"

  toEmojiMart: ->
     emoji = @get('emoji')
     if emoji.colons?
      # This is a not-yet persisted reaction, so the emoji object is in the
      # emoji-mart data format
      return { colons: emoji.colons, skin: emoji.skin }
     emojiMartSkinValue = unifiedSkinMap[emoji.skinVariation]
     return {
      colons: ":#{emoji.shortName}#{if emojiMartSkinValue then '::skin-tone-' + emojiMartSkinValue else ''}:",
      skin: emojiMartSkinValue || 1
     }

  toJSON: (opts = {}) ->
    data = super
    return {
      unified: data.emoji.unified.toUpperCase(),
      skinVariation: skinUnifiedMap[data.emoji.skin]
    }




// WEBPACK FOOTER //
// ./app/scripts/models/reaction.coffee